import React from 'react'
import { parseISO, format } from 'date-fns'
import { AlertTriangle } from 'react-feather'

import Tooltip from './Tooltip'

const REASONS = {
  HardBounce: 'Hard bounce',
  SpamComplaint: 'Spam complaint',
  ManualSuppression: 'Manually suppressed',
  InactiveRecipient: 'Rejected by Postmark'
}

// Renders nothing when deliverable, so call sites need no guard.
export default function EmailSuppressionBadge({ suppression, className }) {
  if (!suppression) return null

  // parseISO is required: date-fns v2 format() throws on a raw string.
  const since = suppression.suppressed_at
    ? format(parseISO(suppression.suppressed_at), 'MMM d, y')
    : null

  return (
    <Tooltip
      content={
        <div className="text-xs leading-snug">
          <div className="font-semibold">
            {REASONS[suppression.reason] || suppression.reason}
          </div>
          {suppression.description && <div className="mt-1">{suppression.description}</div>}
          {suppression.email && <div className="mt-1 opacity-75">{suppression.email}</div>}
        </div>
      }
    >
      <span className={['pill pill-red text-xs inline-flex items-center', className]}>
        <AlertTriangle size={12} className="mr-1" />
        {since ? `Undeliverable since ${since}` : 'Undeliverable'}
      </span>
    </Tooltip>
  )
}
